import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FiChevronDown } from "react-icons/fi";
import SectionHeading from "../../../components/SectionHeading";
import { faqContent } from "./certificationContent";

const CertificationFaq = () => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section
      className="bg-gray-50 py-14 lg:py-20"
      aria-labelledby="certification-faq-heading"
    >
      <div className="brand-col">
        <SectionHeading id="certification-faq-heading" title={faqContent.title} />
        <div className="mx-auto max-w-3xl space-y-4">
          {faqContent.items.map((item, index) => {
            const open = openIndex === index;
            const panelId = `certification-faq-panel-${index}`;
            return (
              <div
                key={item.question}
                className="overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-sm"
              >
                <button
                  type="button"
                  className="flex w-full items-center justify-between gap-4 p-5 text-left"
                  aria-expanded={open}
                  aria-controls={panelId}
                  onClick={() => setOpenIndex(open ? null : index)}
                >
                  <span className="text-sm md:text-base font-bold text-gray-900">
                    {item.question}
                  </span>
                  <motion.span
                    animate={{ rotate: open ? 180 : 0 }}
                    transition={{ duration: 0.3 }}
                    className="flex-shrink-0 text-[var(--brand-primary)]"
                  >
                    <FiChevronDown size={20} aria-hidden="true" />
                  </motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {open && (
                    <motion.div
                      id={panelId}
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3, ease: "easeOut" }}
                      className="overflow-hidden"
                    >
                      <p className="px-5 pb-5 text-sm md:text-base leading-relaxed text-gray-600">
                        {item.answer}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CertificationFaq;
